// extracted by mini-css-extract-plugin
module.exports = {"newsOverview":"NewsOverview_newsOverview__3ZBGa"};